<template>
	<div>
        <div v-show="parent2Show">
            <h3><span>门店上传</span></h3>
            <Form :label-width="120">
                <Form-item label="批量上传：">
                    <Row>
                        <Col span="10">
                            <Upload
                                ref="upload"
                                action="/checker_web/web/store/excelStores"
                                :before-upload="handleUpload"
                                :format="['xlsx']"
                                :on-success="fileSuccessFn"
                                :show-upload-list="false"
                                >
                                <Button type="ghost" icon="ios-cloud-upload-outline">上传文件</Button>
                            </Upload>
                        </Col>
                   </Row>
               </Form-item>
           </Form>
            <el-dialog title="批量上传" :visible.sync="addShow">
                <p>确认批量上传吗？</p>
                <div slot="footer" class="dialog-footer">
                    <Button @click="addShow=false">取 消</Button>
                    <Button type="primary" @click="axiosFn">确 定</Button>
                </div>
            </el-dialog>
        </div>
	</div>
</template>
<script>
    export default {
    	data(){
        	return{
                addShow:false,
                batchForm: {                        //批量添加
                    file:'',
                },
        	}
        },
        watch:{
            $route(to,from){
                if(to.path == '/store/addStore'){
                    this.$store.dispatch('parent2ShowFn');
                    this.getData();
                }
            }
        },
        created(){
            this.$store.dispatch('parent2ShowFn');
        },
        computed: {
            parent2Show () {
                return this.$store.state.parent2Show;
            }
        },
        methods:{
            batchAdd(name){
                var _this=this;
                this.$refs[name].validate((valid) => {
                    if(valid){
                       _this.addShow=true;
                    }else{
                        this.$Message.error('表单验证失败!');
                    }
                })
            },
            axiosFn(){
                this.addShow=false;
                var _this=this;
                _this.$http.post('/web/store/excelStores',
                    _this.batchForm).then(function(res){
                        if(res.success){
                            _this.$Notice.success({
                                title:'批量上传门店',
                                desc:res.message
                            });
                            _this.$refs.batchAdd.resetFields();
                        }else{
                            _this.$Notice.error({
                                title:'批量上传门店',
                                desc:res.message,
                            });
                        }
                    }).catch(function(res){
                        _this.$Notice.error({
                            title:'批量上传门店',
                            desc:'批量上传门店失败！'
                        });
                    });
            },
            fileSuccessFn(res){             //文件上传成功执行的钩子函数
                if(res.success){
                    this.$Notice.success({
                        title:'文件上传',
                        desc: '上传成功'
                    });
                    this.$router.push({path:'/store'});
                }else{
                    this.$Notice.error({
                        title:'文件上传',
                        desc: res.message
                    });
                }
            },
            handleUpload(file){             //文件开始上传时执行的钩子函数
                var type=file.name.substring(file.name.lastIndexOf('.')+1,file.name.length);
                if(type === 'xlsx'){
                    this.file=file;
                }else{
                    this.$Notice.error({
                        title: '文件上传',
                        desc: '仅限.xlsx格式的文件'
                    });
                    return false;
                }   
            },
        }
    }
</script>

<style scoped>
h3 {margin:20px 0;line-height:30px;border-bottom:1px dotted #ccc;}
h3 span {font-size: 15px;padding: 0 10px;display: inline-block;border-bottom: 4px solid #ccc;}
</style>


// WEBPACK FOOTER //
// src/components/store/addStore.vue